import { render, staticRenderFns } from "./PortalDataField.vue?vue&type=template&id=fbf6ab66"
import script from "./PortalDataField.vue?vue&type=script&lang=ts"
export * from "./PortalDataField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports